var footerImage = $('.sw-hero__media img').attr('data-srcset');
$('.sw-hero__media img').attr('src', footerImage);
$("#homeStartorderOnlyFooter").removeClass('d-none').addClass("show-footer-order-button-mobile-tab");
$("#subwayRegisterTradeMark").addClass("marginBottom85");
if ($('[data-component="footer"]').length) {
    (function () {
        'use strict';

        var xssFilters = require('xss-filters');
        var $footer = $('footer');
        var $config = $('#footer-settings');
        var language = $('html').attr('lang') || 'en-us';

        var options = {
            templateUrl: encodeURI($config.data('footerTemplateSrc')) || '',
            dataUrl: encodeURI($config.data('footerDataSrc')) || '',
            htmlKey: 'roFooterHtml',
            defaultLocale: language,
            storageSource: 'sessionStorage'
        };

        var footerData;
        var $footerTemplate;
        var footerHtml;
        var requests = [];

        var sessionStorageExists = subwayScript.isLocalStorageSupported(options.storageSource);

        var loadTemplate = function () {
            var source = $('#template-footer').html();

            if (!source) {
                return;
            }

            var template = Handlebars.compile(source);
            var html = template(footerData);

            if (sessionStorageExists) {
                sessionStorage.setItem(options.htmlKey, html);
            }

            $footer.html(html);
        };

        var getFooterData = function (data) {
            footerData = data;
        };

        var fetchFooterData = function () {
            return subwayScript.crossDomainAjax(options.dataUrl,
                getFooterData,
                true);
        };

        var getFooterTemplate = function (template) {
            $footerTemplate = $(template);

            $footer.append($footerTemplate);
        };

        var fetchFooterTemplate = function () {
            return subwayScript.crossDomainAjax(options.templateUrl,
                getFooterTemplate,
                true);
        };

        if (sessionStorageExists && (footerHtml = xssFilters.inHTMLData(sessionStorage.getItem(options.htmlKey)))) {
            $footer.html(footerHtml);
        } else {
            requests.push(fetchFooterTemplate());
            requests.push(fetchFooterData());

            $.when.apply($, requests)
                .done(function () {
                    loadTemplate();
                });
        }
    })();
}


if ($('#frmGlobalFooter').length) {
    (function () {
        'use strict';
        var $form = $('#frmGlobalFooter');
        var $guestCountryForm = $('#frmGuestCountry');
        $(function () {
            var action = $form[0].action;
            ajaxGetResults(action, $form);
            if (orderViewModel.Analytics.guestCountry === "" && orderViewModel.hasLoggedIn) {
                var guestCountryAction = $guestCountryForm[0].action;
                ajaxGuestCountry(guestCountryAction);
            }
            else if (orderViewModel.hasLoggedIn) {
                analytics.setStoreIsoCodes(orderViewModel.Analytics.guestCountry);
            }
            else {
                analytics.setStoreIsoCodes(analytics.fallbackCountry);
            }
        });

        function ajaxGetResults(postUrl, form) {
            $.ajax({
                url: postUrl,
                type: 'POST',
                data: form.serialize(),
                success: function (data) {
                    $('#frmGlobalFooter').html(data);
                },
                error: function (jqXhr) {
                    // To handle time out error or any other errors
                    ajaxSafetyFooter();
                }
            });
        }

        function ajaxSafetyFooter() {
            var $form = $('#frmSafetyFooter');
            $.ajax({
                url: $form[0].action,
                type: 'GET',
                success: function (data) {
                    $('#frmGlobalFooter').html(data);
                },
                error: function (jqXhr) {
                }
            });
        }
        function ajaxGuestCountry(postUrl) {
            $.ajax({
                url: postUrl,
                type: 'GET',
                success: function (data) {
                    orderViewModel.Analytics.guestCountry = data.GuestCountry;
                    orderViewModel.save();
                    analytics.setStoreIsoCodes(orderViewModel.Analytics.guestCountry);
                },
                error: function (jqXhr) {
                    subwayScript.showAjaxError(jqXhr);
                }
            });
        }
    })();
}

if ($('#frmGuestCountry').length) {
    (function () {
        'use strict';
        var $guestCountryForm = $('#frmGuestCountry');
        $(function () {
            if (orderViewModel.Analytics.guestCountry === "" && orderViewModel.hasLoggedIn) {
                var guestCountryAction = $guestCountryForm[0].action;
                ajaxGuestCountry(guestCountryAction);
            }
            else if (orderViewModel.hasLoggedIn) {
                analytics.setStoreIsoCodes(orderViewModel.Analytics.guestCountry);
            }
            else {
                analytics.setStoreIsoCodes(analytics.fallbackCountrys);
            }
        });

        function ajaxGuestCountry(postUrl) {
            $.ajax({
                url: postUrl,
                type: 'GET',
                success: function (data) {
                    orderViewModel.Analytics.guestCountry = data.GuestCountry;
                    orderViewModel.save();
                    analytics.setStoreIsoCodes(orderViewModel.Analytics.guestCountry);
                },
                error: function (jqXhr) {
                    subwayScript.showAjaxError(jqXhr);
                }
            });
        }
    })();
}

function setCookie() {
    var now = new Date();
    var expireTime = now.toUTCString(now.setTime(now.getTime() + 100 * 36000));
    var cookieName = 'UserProfileCacheKey';
    var userProfileCookie = {
        isLoggedIn : false,
        displayName : null,
        tokens : 0,
        rewards : 0.00,
        favoriteStoreId : null,
        recentStoreId : null,
        guestId : null,
        guestCountry: null,
        guestEmail:null,
        loyaltyId : null,
        encryptedToken : null,
        cart: 0,
        EmailOptInProfile: null
    };

    if (orderViewModel.hasLoggedIn) {
        userProfileCookie.displayName = $('#dtmUserName').val();
        userProfileCookie.guestId = $('#dtmGuestID').val();
        userProfileCookie.guestEmail = encodeURIComponent($('#dtmGuestEmail').val());
        userProfileCookie.loyaltyId = $('#dtmLoyaltyId').val();
        userProfileCookie.isLoggedIn = orderViewModel.hasLoggedIn;
        userProfileCookie.EmailOptInProfile = orderViewModel.EmailOptInProfile;
    } else {
        var jsonString = JSON.stringify(userProfileCookie);
        document.cookie = cookieName + "=" + jsonString + ";domain=.subway.com;path=/; expires=" + expireTime;
    }
    if (orderViewModel.store && orderViewModel.store.StoreId) {
        userProfileCookie.recentStoreId =  orderViewModel.store.StoreId;
    }
    if (orderViewModel.Analytics && orderViewModel.Analytics.guestCountry) {
        userProfileCookie.guestCountry = orderViewModel.Analytics.guestCountry;
    }
    if (orderViewModel.currentOrder && orderViewModel.currentOrder.cartQuantity) {
        userProfileCookie.cart = Number(orderViewModel.currentOrder.cartQuantity);
    }
    //TODO
    if (orderViewModel.currentOrder.cartQuantity || orderViewModel.store.StoreId || orderViewModel.Analytics.guestCountry || orderViewModel.hasLoggedIn) {
        var jsonString = JSON.stringify(userProfileCookie);
        document.cookie = cookieName + "=" + jsonString + ";domain=.subway.com;path=/; expires=" + expireTime;
    }
    if (!getCookie('isStoreChange') && orderViewModel.hasLoggedIn) {
        subwayScript.setCookie('isStoreChange', false, 90);
    }
    //var jsonString = JSON.stringify(userProfileCookie);
    //   document.cookie = cookieName + "=" + jsonString + ";domain=.subway.com;path=/; expires=" + expireTime;
}

setCookie.call();

function setDropdownLanguage() {
    var Language = orderViewModel.headerFooterLanguageCode;
    if( $("html").attr("lang") == Language) {
        $("#languageDropdown option[value='" + Language + "']").prop("selected", true);
        $("#languageDropdown option[value='" + Language + "']").attr("selected", 'selected');
    }
    
}

(() => {
    if (window.location.href.indexOf("menu") > 0 && window.location.href.indexOf('category') <= 0) {
        if (orderViewModel.orderType == "delivery") {
            $('#DeliveryFeeDescription').removeClass('d-none');
            $('.body-top-margin').hide();
        }
    }
})();